<script setup>
import { privacyPage } from '@/graphql/queries/privacy.js'

definePageMeta({
  layout: 'default',
})

const { locale } = useI18n()

const variables = computed(() => ({
  locale: locale.value,
}))

const { data } = await useGraphql(privacyPage, variables)

if (!data.value.privacy) {
  throw createError({ statusCode: 404 })
}

const page = computed(() => data?.value.privacy)

const seo = computed(() => page?.value.seo || {})
useSeo(seo)
</script>

<template>
  <div class="privacy-page p-top-1a">
    <p v-if="page.titolo" class="intro-page-title text-3 row-270-20 max">
      {{ page.titolo }}
    </p>
    <PaginePrivacyBody v-if="page.testo" :body="page.testo" />
  </div>
</template>
